module.exports = __webpack_public_path__ + "static/media/item-2.9900a731.jpeg";